import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SursReciprocalReportService {
  private readonly baseUrl = `${environment.apiUrl}/report`;

  constructor(private http: HttpClient) {}

  generateSursReciprocalExport(request: {
    benefitBeginDate: string;
    benefitEndDate: string;
  }): Observable<{ token: string }> {
    return this.http.post<{ token: string }>(
      `${this.baseUrl}/surs-reciprocal-report/generate-export`,
      request
    );
  }

  downloadSursReciprocalExport(token: string): Observable<Blob> {
    return this.http.get(
      `${this.baseUrl}/surs-reciprocal-report/download-export?token=${token}`,
      {
        responseType: 'blob',
      }
    );
  }
}
